import { DesignPage, DesignPageMediaItem, DesignStructure } from '@gelato-api-ui/core/designs/design-structure';

export const getUsedAssetIds = (designStructure: DesignStructure): string[] => {
  const assetIds = [];

  (designStructure?.spreads || []).forEach(spread => {
    (spread?.pages || []).forEach((page: DesignPage) => {
      (page?.groups?.media || []).forEach((element: DesignPageMediaItem) => {
        if (!element?.imageId) {
          return;
        }

        assetIds.push(element.imageId);
      });
    });
  });

  return assetIds;
};
